var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnidades({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 11.875H15.8333V13.4583H14.1666V11.875ZM14.1666 8.70836H15.8333V10.2917H14.1666V8.70836ZM14.1666 5.54169H15.8333V7.12503H14.1666V5.54169ZM11.45 5.54169L12.5 6.20669V5.54169H11.45Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33331 2.375V3.57042L9.99998 4.62333V3.95833H17.5V15.0417H14.1666V16.625H19.1666V2.375H8.33331Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80831 4.51251L12.5 8.1146V16.625H0.833313V8.29668L6.80831 4.51251ZM8.33331 15.0417H10.8333V8.83501L6.80831 6.4046L2.49998 9.00918V15.0417H4.99998V10.2917H8.33331V15.0417Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnidades);
export default __webpack_public_path__ + "static/media/Unidades.f05fb92e9def389be1f7e7601c513ef3.svg";
export { ForwardRef as ReactComponent };